import { ElementRef, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AffiliateService } from '@app/core/affiliate.service';
import { HttpClient } from '@angular/common/http';

export class AnimatedModalComponent implements OnInit {
  protected modalContentElement: Element;

  constructor(protected _elRef: ElementRef, protected _renderer: Renderer2) {}

  ngOnInit() {
    this.modalContentElement = this._elRef.nativeElement.closest('.modal-content');

    this._renderer.addClass(this.modalContentElement, 'animated');
    this._renderer.addClass(this.modalContentElement, 'fade');
    setTimeout(() => {
      this._renderer.addClass(this.modalContentElement, 'show');
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/animated-modal.component.ts